module.exports = __webpack_public_path__ + "static/media/SA.6cc601db.svg";